<template>
  <status-log-pop-up
    ref="inner"
    title="CUSTOMER LOGS"
    :columns="columns"
    :fetch-fn="fetchFn">
    <template #rows="{ data, buildDiffRows }">
      <vs-tr :key="i" v-for="(_, i) in data">

        <vs-td :data="data[i].created_at || data[i].occurred_at">
          {{ formatLogDate(data[i]) }}
        </vs-td>

        <vs-td :data="data[i].event">
          <vs-chip transparent :color="getEventColor(data[i].event)">
            {{ formatEvent(data[i].event) }}
          </vs-chip>
          <span v-if="data[i].relation" class="text-xs text-grey ml-1">({{ data[i].relation }})</span>
        </vs-td>

        <vs-td :data="data[i].status">
          <vs-chip transparent color="primary" v-if="data[i].status">
            {{ data[i].status }}
          </vs-chip>
          <span v-else>—</span>
        </vs-td>

        <vs-td :data="data[i].causer">
          {{ data[i].causer ? data[i].causer.name : 'System' }}
        </vs-td>

        <template slot="expand">
          <div class="con-expand-users w-4/5">
            <vs-table v-if="buildDiffRows(data[i].changes || data[i].properties).length" noDataText="" class="w-full">
              <template slot="thead">
                <vs-th>CHANGED FIELD</vs-th>
                <vs-th>PREVIOUS VALUE</vs-th>
                <vs-th>NEW VALUE</vs-th>
              </template>
              <template>
                <vs-tr v-for="(row, j) in buildDiffRows(data[i].changes || data[i].properties)" :key="j">
                  <vs-td>{{ row.field }}</vs-td>
                  <vs-td>{{ row.old }}</vs-td>
                  <vs-td>{{ row.new }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <p v-else class="text-grey text-sm p-4">No changes recorded for this event.</p>
          </div>
        </template>

      </vs-tr>
    </template>
  </status-log-pop-up>
</template>

<script>
import StatusLogPopUp from '@/components/popups/activity-logs/StatusLogPopUp.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ActivityLogRepository = RepositoryFactory.get('activity')

export default {
  name: 'ViewCustomerLogPopUp',
  components: { StatusLogPopUp },
  data() {
    return {
      columns: [
        { label: 'DATE/TIME',   width: '25%' },
        { label: 'EVENT',       width: '30%' },
        { label: 'STATUS',      width: '15%' },
        { label: 'DONE BY',     width: '30%' },
      ],
      fetchFn: async (id, page, perPage) => {
        const response = await ActivityLogRepository.getCustomerLogs(id, page, perPage)
        const result = response && response.data ? response.data : {}
        return { logs: result.data || [], meta: result.meta }
      },
    }
  },
  methods: {
    openPopup(id, code = '') {
      this.$refs.inner.openPopup(id, { subtitle: code })
    },
    getEventColor(event) {
      if (!event) return 'primary'
      const e = event.toLowerCase()
      if (e.includes('add') || e.includes('create')) return 'success'
      if (e.includes('update') || e.includes('edit')) return 'warning'
      if (e.includes('remove') || e.includes('delete')) return 'danger'
      return 'primary'
    },
    formatEvent(event) {
      if (!event) return ''
      return event.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    },
    formatLogDate(item) {
      if (!item) return ''
      if (item.created_at) {
        return this.__dateTimeFormatter(item.created_at)
      }
      if (item.occurred_at) {
        if (typeof item.occurred_at === 'string' && /^\d{2}\/\d{2}\/\d{4}/.test(item.occurred_at)) {
          return item.occurred_at
        }
        return this.__dateTimeFormatter(item.occurred_at)
      }
      return '—'
    }
  },
}
</script>

<style scoped>
.status-log-pop-up >>> .vs-popup {
  min-width: 70% !important;
}
</style>
